export default {
    open: "Answer now",
    approve: "Approve now",
    "You have an unapproved orders": "You have orders to approve",
    "You have orders to approve": "You have orders to approve"
}